import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

export default function SeoAudit() {
  const [audit, setAudit] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    document.title = "SEO audit — Admin";
    axios
      .get("/api/admin/seo/audit")
      .then((res) => {
        if (res.data.status === 200) {
          setAudit(res.data.audit || null);
        } else {
          setError("The audit could not be loaded.");
        }
      })
      .catch(() => setError("The audit could not be loaded."));
  }, []);

  return (
    <div className="container-fluid py-3">
      <div className="admin-card bg-white rounded-3 shadow-sm border mb-4">
        <div className="p-4 border-bottom">
          <h4 className="mb-1">SEO audit</h4>
          <p className="text-muted mb-0">
            These checks read the live catalog. An empty list means these checks found nothing to change.
          </p>
        </div>
        <div className="p-4">
          {error && <div className="alert alert-warning">{error}</div>}
          {!audit && !error && <p className="text-muted mb-0">Checking the catalog…</p>}
          {audit && (
            <>
              <p className="mb-3">
                Canonical: <strong>{audit.canonical || "Not set"}</strong>
                {audit.sitemap_url && (
                  <>
                    {" "}
                    · <a href={audit.sitemap_url} target="_blank" rel="noreferrer">Sitemap</a>
                  </>
                )}
              </p>
              {audit.issues && audit.issues.length > 0 ? (
                <div className="d-flex flex-column gap-3">
                  {audit.issues.map((issue, index) => (
                    <div key={`${issue.code}-${index}`} className="border rounded-3 p-3">
                      <div className="d-flex justify-content-between gap-3 flex-wrap">
                        <div>
                          <div className="fw-semibold">{issue.title}</div>
                          <div className="text-muted small mt-1">{issue.detail}</div>
                        </div>
                        {issue.href && (
                          <Link to={issue.href} className="btn btn-sm btn-outline-dark">
                            Open
                          </Link>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="border rounded-3 p-3">No issues in the checks that ran.</div>
              )}
              {audit.checks_run && (
                <p className="text-muted small mt-4 mb-0">
                  Checks: {audit.checks_run.join(" · ")}
                </p>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
